import { useEffect, useState } from 'react';

/**
 * Tracks whether form values have changed from their initial state.
 * Uses deep JSON comparison to handle nested objects.
 */
const useFormDirtyState = (initialValues: any, currentValues: any): boolean => {
    const [isDirty, setIsDirty] = useState(false);

    useEffect(() => {
        setIsDirty(
            JSON.stringify(currentValues) !== JSON.stringify(initialValues),
        );
    }, [currentValues, initialValues]);

    return isDirty;
};

export default useFormDirtyState;
